import React, { useRef } from "react";
import "./Partners.scss";

import p1 from "../../../Assets/images/MC Square.png";
import p2 from "../../../Assets/images/DEKAT.png";
import p3 from "../../../Assets/images/DRS.png";
import p4 from "../../../Assets/images/RNG.png";
import p5 from "../../../Assets/images/1.png";
import p6 from "../../../Assets/images/2.png";

const partners = [
  { name: "MC square", logo: p1 },
  { name: "DEKAT", logo: p2 },
  { name: "DRS ENGINEERING", logo: p3 },
  { name: "RNG", logo: p4 },
  { name: "NEPAL GOVT", logo: p5 },
  { name: "NEPAL ARMY", logo: p6 },
];

const Partners = () => {
  const marqueeRef = useRef(null);

  const handleMouseEnter = () => {
    marqueeRef.current.style.animationPlayState = "paused";
  };
  const handleMouseLeave = () => {
    marqueeRef.current.style.animationPlayState = "running";
  };

  return (
    <div className="partner-marquee-section">
      <hr />
      <p className="partner-marquee-title">
        Working alongside the Best and Brightest
      </p>

      <div className="partner-marquee-container">
        <div className="partner-marquee" ref={marqueeRef}>
          {partners.concat(partners).map((partner, idx) => (
            <div
              className="partner-marquee-logo"
              key={idx}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <img src={partner.logo} alt={partner.name} />
              {/* <span>{partner.name}</span> */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Partners;
